import { observable, action, makeObservable } from 'mobx'

class Liquidation {
    constructor() {
        this.id = null
        this.status = null
        this.invoiceTotal = null
        this.subTotal = null
        this.liquidationPeriod = null
        this.liquidationDate = null
        this.title = null
        this.subtitle = null
        this.footer = null
        this.withholdings = null
        this.incentivesTotal = null
        this.policyLiquidations = []
        this.liquidationFile = null
        this.invoiceFile = null

        makeObservable(this, {
            // observables
            id: observable,
            status: observable,
            invoiceTotal: observable,
            subTotal: observable,
            liquidationPeriod: observable,
            liquidationDate: observable,
            title: observable,
            subtitle: observable,
            footer: observable,
            withholdings: observable,
            incentivesTotal: observable,
            policyLiquidations: observable,
            liquidationFile: observable,
            invoiceFile: observable,

            // actions
            setLiquidation: action,
        })
    }

    setLiquidation(value) {
        this.id = value?.id
        this.status = value?.status
        this.invoiceTotal = value?.invoiceTotal
        this.subTotal = value?.subTotal
        this.liquidationPeriod = value?.liquidationPeriod
        this.liquidationDate = value?.liquidationDate
        this.title = value?.title
        this.subtitle = value?.subtitle
        this.footer = value?.footer
        this.withholdings = value?.withholdings
        this.incentivesTotal = value?.incentivesTotal
        this.policyLiquidations = value?.policyLiquidations 
        this.liquidationFile = value?.liquidationFile
        this.invoiceFile = value?.invoiceFile
    }
}

export default Liquidation
